document.addEventListener("DOMContentLoaded", function () {
  const stockDisplayWrapper = document.getElementById("variant-stock-status");
  const variantSelect = document.querySelector('[name="id"]');

  if (!stockDisplayWrapper || !variantSelect) return;

  const variantDataRaw = stockDisplayWrapper.getAttribute("data-variants");
  let variantData = [];

  try {
    variantData = JSON.parse(variantDataRaw);
  } catch (e) {
    console.error("Failed to parse variant data:", e);
    return;
  }

  function updateStockDisplay(variantId) {
    const variant = variantData.find((v) => v.id == variantId);
    if (!variant) return;

    let message = "";
    let color = "red";
    const qty = variant.inventory_quantity;

    if (variant.available) {
      if (qty > 10) {
        message = "In Stock";
        color = "green";
      } else if (qty > 0) {
        message = `Only ${qty} left in stock!`;
        color = "orange";
      } else {
        message = "Out of Stock";
      }
    } else {
      message = "Unavailable";
    }

    stockDisplayWrapper.innerHTML = `<p style="font-weight:bold; padding:5px 0; font-size:1.2rem; color:${color};">${message}</p>`;
  }

  // Initial load
  const initialId = stockDisplayWrapper.getAttribute("data-selected-id");
  updateStockDisplay(initialId);

  // On variant change
  variantSelect.addEventListener("change", function () {
    updateStockDisplay(this.value);
  });
});
